// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CreateAlertMessageSelectorTemplate } from "../../../templates.js";
import { ContainerControl } from "../../elements/ContainerControl.js";
import { Resources } from "../../../Commons/properties/Resources.js";
import { AlertType, AlertTypeMap } from "../../../Utils/Alert/AlertType.js";
import { AlertConditionMap } from "../../../Utils/Alert/AlertCondition.js";

export let CreateAlertMessageSelector = ContainerControl.extend({
    template: CreateAlertMessageSelectorTemplate,
    data: function ()
    {
        return {
            label: '',
            messageText: '',
            placeholder: ''
        }
    }
})

CreateAlertMessageSelector.prototype.getType = function () { return 'CreateAlertMessageSelector' };

CreateAlertMessageSelector.prototype.oninit = function ()
{
    ContainerControl.prototype.oninit.call(this)

    this.observe('instrument alertTypeValue alertConditionValue alertValue', this.updateAlertMessageText)
    Resources.onLocaleChange.Subscribe(this.localize, this);
    this.localize();
}

CreateAlertMessageSelector.prototype.updateAlertMessageText = function ()
{
    let instrument = this.get('instrument');
    if (!instrument)
        return;

    let alertType = this.get("alertTypeValue");

    let condition = this.get("alertConditionValue");
    let value = this.get("alertValue");

    let formattedValue = '';
    if (alertType === AlertType.CHANGE)
        formattedValue = value.toFixed(2);
    else if (alertType === AlertType.VOLUME)
        formattedValue = instrument.DataCache.formatVolume(instrument, value);  //value.toString();
    else
        formattedValue = instrument.formatPrice(value);

    let alertTypeText = Resources.getResource('panel.watchlist.' + AlertTypeMap[alertType])
    let bodyMessageText = instrument.DisplayName() + ' ' + alertTypeText + ' ' +
        Resources.getResource('screen.Alerts.Condition.' + AlertConditionMap[condition]) + ' ' + formattedValue;

    this.set('messageText', bodyMessageText)
}

CreateAlertMessageSelector.prototype.dispose = function ()
{
    Resources.onLocaleChange.UnSubscribe(this.localize, this)

    ContainerControl.prototype.dispose.call(this)
}

CreateAlertMessageSelector.prototype.localize = function ()
{
    this.set('label', Resources.getResource('screen.Alerts.Message'))
    this.set('placeholder', Resources.getResource('screen.Alerts.Button.Create.Tooltip'))
}